"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLink = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const StyledSpan = styled_components_1.default.span `
  &.email {
    text-transform: lowercase;
  }
  &:not(.email) {
    text-transform: capitalize;
  }
`;
const UserLink = props => {
    const { user, type = 'name', disableLink, to } = props;
    if (!user) {
        return null;
    }
    const asEmail = type === 'email';
    const displayText = (react_1.default.createElement(StyledSpan, { className: asEmail ? 'email' : undefined }, asEmail ? user.email : `${user.firstName || ''} ${user.lastName || ''}`));
    const path = typeof to === 'function' ? to(user.id) : to || `/portal/users/${user.id}`;
    return disableLink ? displayText : react_1.default.createElement(react_router_dom_1.Link, { to: path }, displayText);
};
exports.UserLink = UserLink;
exports.default = exports.UserLink;
//# sourceMappingURL=UserLink.js.map